import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ApplicationWizard } from '../../../components/wizard/applicationWizard';
import { aofForm } from '../../../FormDefinitions';
import { useFormContext } from '../formContext';

const AdvanceOverseasFindingForm = (props: RouteComponentProps<{ applicationId: string, page?: string }>) => {
    const { match: { params: { applicationId } } } = props;
    const appId = (applicationId && parseInt(applicationId)) || 0;
    return (
        <useFormContext.Provider applicationId={appId} >
            <ApplicationWizard
                {...props}
                {...aofForm}
                applicationId={appId}
            />
        </useFormContext.Provider>
    );
};

export default AdvanceOverseasFindingForm;
